<script setup lang="ts">
import { useRouter }  from '#imports'
import { useI18n } from 'vue-i18n'
import { computed, onMounted, ref } from 'vue'
import { faArrowLeft } from '@fortawesome/duotone-regular-svg-icons'
import useOidc from '~/composables/useOidc'
import useError from '~/composables/useError'
import Button from '~/components/ui/Button.vue'
import AuSpinner from '~/components/ui/AuSpinner.vue'
import AuCallout from '~/components/ui/AuCallout.vue'

const { t } = useI18n()
const router = useRouter()
const { manager, getRedirectUri, createCookie, removeRedirectUri } = useOidc()
const { getErrorMessage } = useError()

const isLoading = ref(false)
const errorMessage = ref('')

const computedError = computed(() => router.currentRoute.value.query?.error_description ?? errorMessage.value)

onMounted(async () => {
  isLoading.value = true
  try {
    await manager.signinCallback().finally(async () => {
      const user = await manager.getUser()
      if (user)
        createCookie(user)
      await router.replace(getRedirectUri())
        .then(() => removeRedirectUri())
    })
  } catch (error) {
    errorMessage.value = getErrorMessage(error)
    throw error
  } finally {
    isLoading.value = false
  }
})
</script>

<template>
  <div
    v-if="isLoading"
    class="absolute inset-0 flex items-center justify-center"
  >
    <AuSpinner />
  </div>
  <div
    v-else-if="computedError"
    class="font-inter mx-1 mt-20 mb-12 rounded-xl p-6 max-md:px-4 sm:mx-4 lg:mx-auto lg:max-w-screen-lg"
  >
    <AuCallout
      variant="error"
      :title="t('login.error.title')"
    >
      {{ computedError }}
    </AuCallout>
    <Button
      href="/"
      class="mt-6"
    >
      <font-awesome-icon :icon="faArrowLeft" />
      {{ t('back') }}
    </Button>
  </div>
</template>
